import React from 'react'
import TopArea from './TopArea'
import WarehouseTable from './WarehouseTable'

const WarehouseArea = ({ handleWarehouseModal, warehouseList, deleteWarehouse, handleeditWarehouseModal }) => {
  return (
    <div className='min-h-[105vh] mx-4 pb-6 md:mx-6'>
      <TopArea handleWarehouseModal={handleWarehouseModal} />
      <WarehouseTable handleeditWarehouseModal={handleeditWarehouseModal} handleWarehouseModal={handleWarehouseModal} deleteWarehouse={deleteWarehouse} warehouseList={warehouseList} />
    </div>
  )
}

export default WarehouseArea
